// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div[data-v-502ce5e9] .v-dialog{border-radius:8px!important}.dialog-title[data-v-502ce5e9]{font-size:16px!important;color:#020202!important;letter-spacing:0!important}.dialog-content[data-v-502ce5e9]{color:#404040!important;font-size:12px!important}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
